import React, { useState, useEffect, useRef } from 'react';
import PDFViewer from '../components/PDFViewer';
import { getCurrentPDF } from '../services/pdfService';

const PDFViewerPage = () => {
  const [pdfData, setPdfData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    loadPDF();
  }, []);

  const loadPDF = async () => {
    try {
      setLoading(true);
      const data = await getCurrentPDF();
      setPdfData(data);
    } catch (err) {
      console.error('Error loading PDF:', err);
      setError('Failed to load tournament information');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="pdf-container">
        <div className="pdf-loading">
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="pdf-container">
        <div className="pdf-error">
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!pdfData || !pdfData.exists) {
    return (
      <div className="pdf-container">
        <div className="pdf-no-content">
          <h2>Tournament Information</h2>
          <p>No tournament information available. Please check back soon!</p>
        </div>
      </div>
    );
  }

  return (
    <div className="pdf-container">
      <div className="pdf-header">
        <h1>Tournament Information</h1>
      </div>
      <div className="pdf-viewer-wrapper" ref={containerRef}>
        <PDFViewer file={pdfData.url} containerRef={containerRef} />
      </div>
    </div>
  );
};

export default PDFViewerPage;
